export const apiBaseURL = process.env.REACT_APP_API_URL;
export const webSocketURL = process.env.REACT_APP_WEBSOCKET_URL;
export const googleMapAPIKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
export const coinBarterApi = process.env.REACT_APP_COINBARTER_API;
export const instantApi = process.env.REACT_APP_INSTANT_API;
